import { useTranslation } from "react-i18next";

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center mb-4">
          {t("features.title_line1")}{" "}
          <span className="text-accent-500">{t("features.title_line2")}</span>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mt-12">
          {/* Large left card */}
          <div className="lg:col-span-1 lg:row-span-2 relative rounded-lg overflow-hidden group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20a%20clean%20cream%20desk%20displaying%20organized%20spreadsheet%20data%20with%20charts%20and%20analytics%2C%20soft%20warm%20morning%20light%20through%20a%20large%20window%20creating%20gentle%20shadows%2C%20minimalist%20workspace%20with%20a%20small%20potted%20succulent%20plant%20and%20ceramic%20mug%2C%20calm%20productive%20atmosphere%2C%20high%20end%20editorial%20photography%20with%20refined%20composition&width=600&height=900&seq=feature-v2-7k3p1&orientation=portrait"
              alt="Zarządzanie arkuszami USFansSpreadsheet"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-primary-500/80 backdrop-blur-sm p-5">
              <span className="text-background-50 text-base font-heading font-semibold">
                {t("features.sheet_management")}
              </span>
            </div>
          </div>

          {/* Top right card */}
          <div className="rounded-lg overflow-hidden relative group cursor-pointer bg-secondary-400">
            <div className="p-6 md:p-8 flex flex-col justify-between h-full min-h-[200px]">
              <div>
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 mb-4">
                  <i className="ri-shield-check-line text-background-50 text-lg"></i>
                </div>
                <h3 className="font-heading text-xl font-semibold text-background-50 mb-2">
                  {t("features.security")}
                </h3>
                <p className="text-background-50/80 text-sm leading-relaxed">
                  Szyfrowanie end-to-end, regularne audyty bezpieczeństwa i pełna zgodność z RODO.
                </p>
              </div>
            </div>
          </div>

          {/* Bottom right card */}
          <div className="rounded-lg overflow-hidden relative group cursor-pointer bg-background-200">
            <div className="p-6 md:p-8 flex flex-col justify-between h-full min-h-[200px]">
              <div>
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/40 mb-4">
                  <i className="ri-bar-chart-line text-foreground-800 text-lg"></i>
                </div>
                <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-2">
                  {t("features.analytics")}
                </h3>
                <p className="text-foreground-700 text-sm leading-relaxed">
                  Zaawansowane raporty, wizualizacje danych i eksport do wielu formatów.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}